module.exports = "\n<div class=\"mainContainer\">\n    <alg-faq-card></alg-faq-card>\n    <alg-call-me></alg-call-me>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-container-components/alg-container-components.component.html
// module id = ./src/app/components/molecules/alg-container-components/alg-container-components.component.html
// module chunks = main